module.exports = __webpack_public_path__ + "static/media/warning-icon-inactive.d5935c87.svg";